
import { LoadingSpinner } from "@/components/ui/loading-spinner";

export const AppLoadingFallback = () => (
  <div className="h-screen w-full flex flex-col items-center justify-center bg-gradient-to-b from-brand-beige-100 to-white">
    <LoadingSpinner size="lg" />
    <p className="mt-4 text-lg text-gray-600">Loading application...</p>
  </div>
);
